import { Grid } from '@material-ui/core';
import {
  getDegree,
  getSchools,
  getStudyPlan,
  getTrainingDomains,
  getTrainingType,
} from '@webapps/business';
import {
  Button,
  FormikAutocomplete,
  FormikAutocompletePx,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line react/prop-types
const FiltersFormation = ({
  formik = {},
  resetParamsUrl,
  handleClose,
  trainingDomains,
  trainingDomainsLoading,
}) => {
  const { classes, css } = useStyles(styles);

  const { data: { content: allSchools = [] } = {}, isLoading: schoolLoading } =
    useQuery(getSchools, {
      key: 'allSchoolsMap',
    });

  const { data: trainingTypes = [], isLoading: trainingTypesLoading } =
    useQuery(getTrainingType, {
      key: 'trainingTypesMap',
    });

  const { data: studyPlans = [], isLoading: studyPlanLoading } = useQuery(
    getStudyPlan,
    {
      key: 'studyPlansMap',
    }
  );

  const { data: degrees = [], isLoading: degreesLoading } = useQuery(
    getDegree,
    {
      key: 'degreeMap',
    }
  );

  const resetFilter = () => {
    resetParamsUrl();
    formik.resetForm();
    formik.handleSubmit();
  };

  return (
    <Grid container>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.name || ''}
          label="Etablissements de formation"
          loading={schoolLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="schools"
          options={allSchools}
          pathValue="id"
          value={allSchools.filter(({ id }) =>
            formik?.values?.schools?.includes(id)
          )}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label="Domaine(s) d'étude(s)"
          name="domains"
          options={trainingDomains}
          pathValue="id"
          value={trainingDomains.find((trainingDomains) => trainingDomains.id === formik.values.domains) || null}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label="Niveau(x) de diplôme(s)"
          loading={degreesLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="degrees"
          options={degrees}
          pathValue="id"
          value={degrees.filter(({ id }) =>
            formik?.values?.degrees?.includes(id)
          )}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label={<FormattedMessage id="map.trainingTypes" />}
          loading={trainingTypesLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="trainingTypes"
          options={trainingTypes}
          pathValue="id"
          value={trainingTypes.filter(({ id }) =>
            formik?.values?.trainingTypes?.includes(id)
          )}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label={<FormattedMessage id="map.studyPlans" />}
          loading={studyPlanLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="studyPlans"
          options={studyPlans}
          pathValue="id"
          value={studyPlans.filter(({ id }) =>
            formik?.values?.studyPlans?.includes(id)
          )}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <Button
          className={css({ borderRadius: '10.0px' })}
          color="primary"
          fullWidth
          onClick={() => {
            handleClose();
            formik.handleSubmit();
          }}
          variant="contained"
        >
          <FormattedMessage id="btnSearch" />
        </Button>
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <Button
          className={css({ borderRadius: '10.0px', backgroundColor: 'white' })}
          color="primary"
          fullWidth
          onClick={resetFilter}
          variant="outlined"
        >
          Réinitialiser
        </Button>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  grid: {
    marginTop: spacing(2),
  },
});

export default FiltersFormation;
